import React, { useCallback } from 'react'
import { addShipmentRow, deleteShipmentRow, updateShipmentRow } from '../../reducer/headerSlice'
import { useDocument } from '@EUForms/hooks/useDocument'
import CCDocDetail from './CCDocDetail'
import RepeatableContainer from '@containers/repeatableContainer'
import { useSelector } from 'react-redux'
import { selectHeaderTabDS } from '@EUForms/selectors'

const CCDoc = ({translate}) => {
  const { ...rest } = useDocument({
    addData: addShipmentRow,
    updateData: updateShipmentRow,
    deleteData: deleteShipmentRow,
    containerKey: 'headerTab',
  })
  const isCCDocEndRequest = useSelector(selectHeaderTabDS).isCCDocEndRequest || '0'
  return (
    <RepeatableContainer
      {...rest}
      otherParams={{ infoType: 'EU_CC_DOCUMENT', type: 'PDF' }}
      tableName='ccDocumentsList'
      reducerName='headerReducer'
      title='ADDITIONAL DOCUMENTS'
      isDisabled={isCCDocEndRequest ==='1'}
      translate={translate}
      style={{ position: 'relative' }}
      renderForm={(params) => <CCDocDetail {...params} />}
    />
  )
}

export default React.memo(CCDoc)
